export const CHANGE_SEARCH_PARAMS = 'device/CHANGE_SEARCH_PARAMS'
